import React, { useState } from 'react';

import PropTypes from 'prop-types';

import { DiskBadgeContainer, FlagIconContainer, FlagIconWrap, ImgWrap, SecondFlagIconWrap } from './styles';
import { LightFlagIcon } from '../LightFlagIcon/LightFlagIcon';
import { LightIcon } from '../LightIcon/LightIcon';
import { LightText } from '../LightText/LightText';

export const LightDiskBadge = (props) => {
    const [errorImageLoading, setErrorImageLoading] = useState(false);
    return (
        <DiskBadgeContainer noBorder={!!props.src || props.noBorder} variant={props.variant} diskSize={props.diskSize}>
            {props.iconName && (
                <LightIcon
                    name={props.iconName}
                    color={props.variant === 'secondary' || props.variant === 'selectedPassive' ? 'purple' : 'darkGray'}
                    size={props.diskSize === 'x-large' ? '64px' : '24px'}
                />
            )}
            {/*Загрузка аватарки*/}
            {props.src && !errorImageLoading && (
                <ImgWrap diskSize={props.diskSize}>
                    <img src={props.src} alt={props.alt} onError={(e) => (props.onError ? props.onError(e) : setErrorImageLoading(true))} />
                </ImgWrap>
            )}
            {/*Текст вместо иконки или аватарки*/}
            {props.diskText && (
                <LightText variant={props.diskSize === 'x-large' ? 'h2' : 'span'} color={'darkGray'}>
                    {props.diskText}
                </LightText>
            )}
            {/*обработка ошибок загрузки изображения*/}
            {errorImageLoading && <LightText color={'darkGray'}>{props.logoSymbol}</LightText>}
            {props.flagName && (
                <FlagIconWrap>
                    <FlagIconContainer>
                        <LightFlagIcon name={props.flagName} size={props.diskSize === 'x-large' ? '40px' : '16px'} />
                    </FlagIconContainer>
                </FlagIconWrap>
            )}
            {props.secondFlagName && (
                <SecondFlagIconWrap>
                    <FlagIconContainer>
                        <LightFlagIcon name={props.secondFlagName} size={props.diskSize === 'x-large' ? '40px' : '16px'} />
                    </FlagIconContainer>
                </SecondFlagIconWrap>
            )}
        </DiskBadgeContainer>
    );
};

LightDiskBadge.propTypes = {
    iconName: PropTypes.string,
    diskSize: PropTypes.oneOf(['small', 'x-large']),
    flagName: PropTypes.string,
    secondFlagName: PropTypes.string,
    src: PropTypes.string,
    alt: PropTypes.string,
    logoSymbol: PropTypes.string,
    onError: PropTypes.func,
    diskText: PropTypes.string,
    noBorder: PropTypes.bool,
};
